import {createTheme} from "@mui/material";

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#069c3f',
            light: '#33c66d',
            dark: '#05662b',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#ffa500',
            light: '#ffb733',
            dark: '#cc8400',
            contrastText: '#ffffff',
        },
        background: {
            default: '#0f140f',    // green-tinted dark background
            paper: '#151a15',
        },
        text: {
            primary: '#f5f5f5',
            secondary: '#d1d1d1',
            disabled: '#a0a0a0',
        },
        grey: {
            50: '#f9f9f9',
            100: '#e0e0e0',
            200: '#c2c2c2',
            300: '#a3a3a3',
            400: '#858585',
            500: '#666666',
            600: '#4d4d4d',
            700: '#333333',
            800: '#1f1f1f',
            900: '#0d0d0d',
        },
        divider: '#2e352d',
    },
    typography: {
        fontFamily: 'Montserrat, Arial, sans-serif',
        h1: {color: '#f5f5f5'},
        h2: {color: '#f5f5f5'},
        h3: {color: '#f5f5f5'},
        h4: {color: '#f5f5f5'},
        h5: {color: '#f5f5f5'},
        h6: {color: '#f5f5f5'},
        body1: {color: '#f5f5f5'},
        body2: {color: '#d1d1d1'},
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                html: {
                    height: '100%',
                    margin: 0,
                },
                body: {
                    height: '100%',
                    margin: 0,
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#069c3f #2e352d',
                },
                '#root': {
                    height: '100%',
                },
            },
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(255, 255, 255, 0.01)',
                    backdropFilter: 'blur(16px) saturate(180%)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: '8px !important',
                    marginBottom: '12px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                    overflow: 'hidden',
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.02)',
                        border: '1px solid rgba(6, 156, 63, 0.4)',
                        boxShadow:
                            '0 6px 20px rgba(6, 156, 63, 0.2),' +
                            '0 4px 12px rgba(0, 0, 0, 0.3),' +
                            'inset 0 1px 0 rgba(255, 255, 255, 0.08)',
                    },
                    '&.Mui-expanded': {
                        backgroundColor: 'rgba(255, 255, 255, 0.02)',
                        border: '1px solid rgba(6, 156, 63, 0.5)',
                        boxShadow:
                            '0 6px 20px rgba(6, 156, 63, 0.25),' +
                            '0 4px 12px rgba(0, 0, 0, 0.4),' +
                            'inset 0 1px 0 rgba(255, 255, 255, 0.08)',
                    },
                    '&:before': {
                        display: 'none',
                    },
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    minHeight: '60px',
                    padding: '0 24px',
                    '&:hover': {
                        backgroundColor: 'rgba(6, 156, 63, 0.02)',
                    },
                    '&.Mui-expanded': {
                        minHeight: '60px',
                        backgroundColor: 'rgba(6, 156, 63, 0.5)',
                        borderBottom: '1px solid rgba(6, 156, 63, 0.2)',
                    },
                },
                content: {
                    '&.Mui-expanded': {
                        margin: '12px 0',
                    },
                },
                expandIconWrapper: {
                    color: '#069c3f',
                    transition: 'transform 0.3s ease',
                    '&.Mui-expanded': {
                        transform: 'rotate(180deg)',
                        color: '#33c66d',
                    },
                },
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                    padding: '24px',
                    borderTop: '1px solid rgba(255, 255, 255, 0.05)',
                    position: 'relative',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: '1px',
                        background: 'linear-gradient(90deg, transparent, rgba(6, 156, 63, 0.2), transparent)',
                    },
                },
            },
        },
    },
});

export default theme;